// Tisort renk adi -> yaklasik hex (Comfort Colors + yaygin renkler). Baski
// onizlemesi tasarimi urunun renginde zeminde gosterir: seffaf/beyaz murekkep
// kareli zeminde gorunmuyordu. Bilinmeyen ad -> adindan koyu/acik tahmini.

const GARMENT_HEX: Record<string, string> = {
  black: "#1f1f1f", white: "#f7f7f5", pepper: "#4a4946", espresso: "#4b3a2f", graphite: "#55565a",
  granite: "#6e6e6c", grey: "#9a9a98", gray: "#9a9a98", "heather grey": "#b5b5b3", "sport grey": "#a7a8aa",
  navy: "#262b3d", "true navy": "#2b3349", "blue jean": "#5a7189", denim: "#5b6f8a", "washed denim": "#7d93ad",
  "royal": "#2e4fa0", "royal caribe": "#3d7fb3", "flo blue": "#6f8fd0", "chambray": "#a9c0d6", "light blue": "#b9d0e3",
  "ice blue": "#c9dbe6", "lagoon blue": "#8cc6cc", "seafoam": "#8fbfa9", "chalky mint": "#a7d6c5", "island green": "#4c9a83",
  moss: "#6b6a48", sage: "#9aa58a", "bay": "#bfc5ae", "light green": "#a8c49a", "blue spruce": "#3f5e58", "emerald": "#2f6b55",
  "military green": "#5b5e3f", olive: "#6b6a3f", khaki: "#b9a77f", sandstone: "#c9b48f", sand: "#d8c8a6", ivory: "#efe7d2",
  natural: "#ece3cc", butter: "#f1dd96", banana: "#f2e3a0", mustard: "#c99b3a", yam: "#c46a35", pumpkin: "#d9772f",
  "burnt orange": "#c4652f", "red": "#b3282d", "crimson": "#9e2f37", "chili": "#9b3a33", "brick": "#8c4a3b", "burgundy": "#5e2a33",
  "maroon": "#5a2531", "berry": "#8a3d5c", "watermelon": "#e4767a", "neon pink": "#ef6fa0", "crunchberry": "#e46f97",
  "blossom": "#efc3cc", "light pink": "#f2c9cf", "peachy": "#f1b89c", "terracotta": "#c06a4f", "orchid": "#b49ac2",
  "violet": "#8d78b8", "grape": "#5d4a7a", "purple": "#5b3f87", "hemp": "#7a6f55", "wine": "#5b2738",
};

export function garmentHex(name: string | null | undefined): string {
  const k = (name || "").toLowerCase().trim();
  if (!k) return "#f4f1ec";
  if (GARMENT_HEX[k]) return GARMENT_HEX[k];
  const hit = Object.keys(GARMENT_HEX).find((c) => k.includes(c));
  if (hit) return GARMENT_HEX[hit];
  return /black|dark|navy|charcoal|espresso|pepper|forest|maroon|burgundy|brown|chocolate/.test(k) ? "#333333" : "#f4f1ec";
}
